// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDH7k1qH13CZAjOnvy1Dm25y00-gdC0YXs",
  authDomain: "neosapien-website.firebaseapp.com",
  projectId: "neosapien-website",
  storageBucket: "neosapien-website.firebasestorage.app",
  messagingSenderId: "498251685305",
  appId: "1:498251685305:web:663e10216dc5ff4e5bea68",
  measurementId: "G-T23JDSBLB6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export { app, analytics };
